import { Role, User, UserGroup, UserGroupWithUserIds } from "./user.types";

export const userMock1: User = {
  uuid: "d2253b9b-5925-4bfd-944d-976c20a60db9",
  id: 1,
  email: "example1@gmail.com",
  avatar: "./image.png",
  first_name: "User 1",
  full_name: "User 1 Test",
  last_name: "Test",
  role: {
    display_name: "System Administrator",
    name: Role.EntityAdmin,
  },
};

export const userMock2: User = {
  uuid: "1234-5678-9101-1122",
  id: 2,
  email: "example2@gmail.com",
  avatar: "./image.png",
  first_name: "User 2",
  full_name: "User 2 Test",
  last_name: "Test",
  role: {
    display_name: "System User",
    name: Role.EntityUser,
  },
};

export const groupMock1: UserGroup = {
  id: "1234-5678-9101-1121",
  name: "Group 1",
  description: "Test Group 1",
  entityId: "1234-5678-9101-1121",
  memberCount: 2,
  createdAt: "2021-01-01",
  updatedAt: "2021-01-01",
};

export const groupMock2: UserGroup = {
  id: "1234-5678-9101-1122",
  name: "Group 2",
  description: "Test Group 2",
  entityId: "1234-5678-9101-1122",
  memberCount: 1,
  createdAt: "2021-01-01",
  updatedAt: "2021-01-01",
};

export const groupWithUserIdsMock1: UserGroupWithUserIds = {
  ...groupMock1,
  userIds: [userMock1.uuid, userMock2.uuid],
};

export const groupWithUserIdsMock2: UserGroupWithUserIds = {
  ...groupMock2,
  userIds: [userMock1.uuid],
};
